export default __webpack_public_path__ + "static/media/exchange.a59bf430.jpg";